import { ConfigService } from "@shuttlerock/configuration";
import { Routes } from "@shuttlerock/router";
import { LoaderFunctionArgs } from "react-router";
import { AuthClient } from "../internal/AuthClient";

export async function loader(_: LoaderFunctionArgs) {
  await AuthClient.logout({
    logoutParams: {
      returnTo: `${ConfigService.APP_URL()}${Routes.Auth.SignIn}`,
    },
  });
  return null;
}
